import React from "react"
import SmartSegmentsListPage from "pages/Segments/components/SmartSegmentsList/SmartSegmentsList"

const SmartSegmentsSetupList = () => {
  return <SmartSegmentsListPage createAllowed={true} />
}

export default SmartSegmentsSetupList
